import {
  GET_USER_SETTINGS,
  SAVE_USER_SETTINGS,
  SET_DEFAULT_SETTINGS,
  GET_USER_SETTINGS_SUCCESS,
  GET_USER_SETTINGS_FAILURE,
} from "./actionTypes";

// Action to initiate settings loading
export const getUserSettings = () => ({
  type: GET_USER_SETTINGS,
});

// Action for successful settings load
export const getUserSettingsSuccess = (settings) => ({
  type: GET_USER_SETTINGS_SUCCESS,
  payload: settings,
});

// Action for failed settings load
export const getUserSettingsFailure = (error) => ({
  type: GET_USER_SETTINGS_FAILURE,
  payload: error,
});

// Action to save settings
export const saveUserSettings = (settings) => ({
  type: SAVE_USER_SETTINGS,
  payload: settings,
});

// Action to set default settings
export const setDefaultSettings = () => ({
  type: SET_DEFAULT_SETTINGS,
});
